import { getBooleanFromValue } from '@/global/utils/utils'

const IMAGE_DATA_KEY = 'logo'
export default {
  name: 'companyTab',

  computed: {
    companyTabConfig () {
      return {
        title: this.$t('base.company'),
        key: 'company',
        visible: getBooleanFromValue(this.permissions?.canReadCompany),
        apiConfig: {
          get: {
            module: 'base',
            route: 'profile/get-company',
            method: 'get'
          },
          post: {
            module: 'base',
            route: 'profile/update-company',
            method: 'post',
            usePatch: false
          }
        },
        hiddenFormKeys: [
          IMAGE_DATA_KEY
        ],
        tabContent: [
          {
            title: this.$t('base.company'),
            component: this.columnsContentComponent,
            showButtons: true,
            cardStyle: {
              maxWidth: '880px'
            },
            rows: [
              {
                type: 'fields',
                columnsCount: 2,
                fields: [
                  {
                    key: 'parent_name',
                    label: this.$t('base/company.parent_company'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'name',
                    label: this.$t('base/company.name'),
                    placeholder: this.$t('base/company.name_placeholder'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'address',
                    label: this.$t('base/company.address'),
                    placeholder: this.$t('base/company.address_placeholder'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'postal_code',
                    label: this.$t('base/company.postal_code'),
                    placeholder: this.$t('base/company.postal_code_placeholder'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'city',
                    label: this.$t('base/company.city'),
                    placeholder: this.$t('base/company.city_placeholder'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'country',
                    label: this.$t('locations.country'),
                    placeholder: this.$t('base/company.identification_number_placeholder'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'identification_number',
                    label: this.$t('base/company.identification_number'),
                    placeholder: this.$t('base/company.identification_number_placeholder'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'language',
                    type: 'autocomplete',
                    label: this.$t('base.language'),
                    placeholder: this.$t('base/company.language_placeholder'),
                    autocomplete_options: {
                      module: 'base',
                      route: 'languages/autocomplete'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              },
              {
                component: this.companyImageComponent,
                key: IMAGE_DATA_KEY,
                style: {
                  height: '287px',
                  width: '100%',
                  padding: 0,
                  borderRadius: '16px'
                },
                images: {
                  keys: [
                    IMAGE_DATA_KEY
                  ],
                  style: {
                    position: 'relative',
                    width: '100%',
                    height: '100%',
                    borderRadius: '16px'
                  }
                },
                bordered: true,
                title: 'Logo',
                max_images: 1,
                creatable: true,
                editable: true,
                visible: true
              },
              {
                component: this.companyMapComponent,
                title: this.$t('base.geolocation'),
                key: 'geolocation',
                creatable: true,
                editable: true,
                visible: true
              }
            ]
          }
        ]
      }
    }
  }
}
